module.exports = fox._r("images/promo/contest/1192x400_esp.png", __webpack_public_path__ + "_/common/images/promo/contest/1192x400_esp.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/promo/contest/1192x400_esp.png
// module id = 424
// module chunks = 2